export default {"src":"/_next/static/media/checkBlue.864eac3a.svg","height":16,"width":16};